<template>
    <div class="content content--registration">
        <div class="small-window">
            <div class="form-wrap">
                <div class="form-wrap__row form-wrap__row--bordered">
                    <c-checkbox v-model="loanRules" :label="'Я ознакомлен и принимаю'">
                        <a class="link link--orange" @click="$modal.show('loanRules')">Правила предоставления микрокредитов <br> ТОО «МФО ФинЛаб»</a>
                    </c-checkbox>
                </div>
                <div class="form-wrap__row form-wrap__row--bordered">
                    <c-checkbox v-model="getFromPKB" :label="'Я разрешаю'">
                        <a class="link link--orange" @click="$modal.show('getFromPKB')">ТОО «МФО ФинЛаб» получить <br> сведения обо мне из кредитных
                            бюро</a>
                    </c-checkbox>
                </div>
                <div class="form-wrap__row form-wrap__row--bordered">
                    <c-checkbox v-model="sendToPKB" :label="'Я разрешаю'">
                        <a class="link link--orange" @click="$modal.show('sendToPKB')">
                            ТОО «МФО ФинЛаб» предоставить <br> сведения обо мне в кредитные
                            бюро</a>
                    </c-checkbox>
                </div>

                <div class="form-wrap__row form-wrap__row--checkbox">
                    <c-checkbox v-model="allComplete" v-on:click.native="uncheckAll" :label="'Я согласен со всеми условиями выше'">
                    </c-checkbox>
                </div>

                <div class="form-button__wrap" v-if="allComplete">
                    <router-link :to="{name: 'Treatment'}" tag="button" class="form-button form-button--yellow form-button--long-text">
                        Продолжить
                    </router-link>
                </div>
            </div>
        </div>

        <modal name="loanRules" :adaptive="modalOptions.adaptive" :scrollable="modalOptions.scrollable" :width="modalOptions.width" :height="modalOptions.height">
            <div class="modal-header">
                <h3 class="modal-header__title">Правила предоставления микрокредитов  ТОО «МФО ФинЛаб»</h3>
                <span class="modal-header__close" v-on:click="$modal.hide('loanRules')">Закрыть</span>
            </div>
            <div class="modal-content" v-html="RULES_MFO"></div>
        </modal>

        <modal name="getFromPKB" :adaptive="modalOptions.adaptive" :scrollable="modalOptions.scrollable" :width="modalOptions.width" :height="modalOptions.height">
            <div class="modal-header">
                <h3 class="modal-header__title">ТОО «МФО ФинЛаб» получить сведения обо мне из кредитных бюро</h3>
                <span class="modal-header__close" v-on:click="$modal.hide('getFromPKB')">Закрыть</span>
            </div>
            <div class="modal-content" v-html="CONSENT_PCB"></div>
        </modal>

        <modal name="sendToPKB" :adaptive="modalOptions.adaptive" :scrollable="modalOptions.scrollable" :width="modalOptions.width" :height="modalOptions.height">
            <div class="modal-header">
                <h3 class="modal-header__title">ТОО «МФО ФинЛаб» получить сведения обо мне из кредитных бюро</h3>
                <span class="modal-header__close" v-on:click="$modal.hide('sendToPKB')">Закрыть</span>
            </div>
            <div class="modal-content" v-html="CONSENT_PROVIDE_PCB"></div>
        </modal>

    </div>
</template>

<script>
    const DOCUMENTS_LIST = [
        'RULES_MFO',
        'CONSENT_TO_PROCESSING',
        'CONSENT_PCB',
        'CONSENT_PROVIDE_PCB'
    ];
    import each from 'lodash/each';

    import {createHelpers} from 'vuex-map-fields';
    import widthMixin from '@/modules/mixins/widthMixin'
    import Raven from 'raven-js'

    const {mapFields: creditFields} = createHelpers({
        getterType: 'credit/getField',
        mutationType: 'credit/updateField',
    });
    export default {
        name: 'Conditions',
        mixins: [widthMixin],
        metaInfo: {
            title: 'Регистрация'
        },
        data() {
            return {

                allComplete: false,

                loanRules: false,
                getFromPKB: false,
                sendToPKB: false,

                RULES_MFO: '',
                CONSENT_TO_PROCESSING: '',
                CONSENT_PCB: '',
                CONSENT_PROVIDE_PCB: '',

            }
        },
        watch: {
            allComplete: function (newVal, oldVal) {
                if(newVal){
                    this.loanRules = newVal;
                    this.getFromPKB = newVal;
                    this.sendToPKB = newVal;
                }
            },
            loanRules: function (newVal, oldVal) {
                    this.allComplete = this.completedAll;
            },
            getFromPKB: function (newVal, oldVal) {
                    this.allComplete = this.completedAll;
            },
            sendToPKB: function (newVal, oldVal) {
                    this.allComplete = this.completedAll;
            },
        },
        computed: {
            modalOptions: function(){
              return {
                  adaptive: true,
                  width: '100%',
                  height: '100%',
                  scrollable: true
              }
            },
            completedAll: function () {
                return this.loanRules && this.getFromPKB && this.sendToPKB;
            },
            ...creditFields([
                'creditID',
                'bankID',
                'IBAN',
                'IBANExternalStatus',
                'IBANExternalError',
            ]),
        },
        methods: {
            uncheckAll: function () {
                if( this.allComplete ){
                    this.loanRules = false;
                    this.getFromPKB = false;
                    this.sendToPKB = false;
                }
            }
        },
        beforeCreate(){
            if( !this.$store.getters['profile/isInited'] ){
                this.$store.dispatch('profile/INIT');
            }
        },
        mounted() {
            this.$store.commit('CHANGE_PROGRESS', {progressBarShow: true, currentPercent: 90, nextPercent: 5});
            this.$store.dispatch('credit/GET_CREDIT_INFO');
            let _this = this;
            let requestArray = [];
            // Формирование списка запросов за документами
            setTimeout(function () {
            each(DOCUMENTS_LIST, function (item, index) {
                requestArray.push(
                    _this.$http.get('/json/document', {params: {documentType: item, creditId: _this.creditID}})
                )
            });

            // Выполнение всех запросов и ожидание их окончания
                _this.$http.all(requestArray).then(
                    _this.$http.spread( (...args)  =>{
                        console.log(args);
                        for (let i = 0; i < args.length; i++) {
                            _this[args[i].config.params.documentType] = args[i].data.data.document;
                        }
                    })
                );
                Raven.captureMessage('Step end: '+_this.$options.name, {
                    level: 'info'
                });
            }, 3000);

        }
    }
</script>

<style lang="scss">
    @import "~@/assets/scss/variable";
    .link{
        font-size: 14px;
        font-family: $RobotoRegular;
        line-height: 16px;
        text-decoration: underline;
        &--orange{
            color: $orange;
            &:hover{
                color: #cd7013;
            }
        }
    }
    .modal-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 15px;
        background: $gray-light;
        position: fixed;
        width: 100%;
        z-index: 1020;
        top: 0;
        left: 0;
        &__title{
            text-align: left;
            font-size: 18px;
            font-family: $RobotoRegular;
        }
        &__close{
            color: $purple-site;
            font-size: 18px;
            text-decoration: underline;
            &:hover{
                cursor: pointer;
                color: #6d1a69;
            }
        }
    }
    .modal-content {
        padding-top: 60px;
        z-index: 1010;
        overflow-y: scroll;
        overflow-x: hidden;
        position: relative;
        min-height: 100vh;
        max-height: 100vh;
        height: 100%;
    }
    .modal-content table{
        max-width: 1260px !important;
        width: 100% !important;
    }
    @media screen and (max-width: 768px){
        .modal-header{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 10px 15px;
            background: $gray-light;
            &__title{
                text-align: left;
                font-size: 14px;
                font-family: $RobotoRegular;
            }
            &__close{
                color: $purple-site;
                font-size: 12px;
                text-decoration: underline;
                &:hover{
                    cursor: pointer;
                    color: #6d1a69;
                }
            }
        }
    }
</style>